// What the site offers, listed under the board on the start page (both the
// wide and the phone layout). Kept short and concrete: it's also what search
// engines and their AI summaries quote.
const HOME_FEATURES = [
    { title: 'Free, nothing to install', text: 'No account, no download and no fees. It runs in the browser on your phone, tablet or computer.' },
    { title: 'Play against the computer', text: 'Easy plays at random, Medium blocks and builds, Hard hunts for double threats.', path: '/play-against-computer' },
    { title: 'Invite friends with a link', text: '2 to 12 players in 2 or 3 teams. Share the link and everyone joins.', path: '/play-with-friends' },
    { title: 'Video calls built in', text: 'See and hear the people you play with (on computers for now), and chat with the table on any screen.', path: '/play-with-friends' },
    { title: 'Find an opponent', text: 'Get matched with another player online for a one-on-one game.' },
    { title: 'Play it your way', text: 'Classic or shuffled board, an optional turn timer, and move highlights on or off.' },
    { title: 'Leaderboard and replays', text: 'Race for the fastest wins against the computer, watch finished games back and rematch in one click.' },
];

export default HOME_FEATURES;
